import { useForm, Controller, } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../FormError";
import * as Yup from "yup";
import { NavLink, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import SelectBox from "../SelectBox";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import {setFromData, saveBusinessInformation, removeLocalData } from "../../../slices/BusinessesSlice";
import { getBusinessFormData } from "../../../Utils/utils/CommanFnc";
import { MessageAlert } from "../MessageAlert";
import {Loading} from "../../Loading"
export function BusinessRegistrationInfo(props) {
  const [businessRegType, setBusinessRegType] = useState([])
  const [isGstinDisbale, setIsGstinDisable] = useState(false)
  const storeState = useSelector((state) => state.businesses)
  const error = useSelector((state) => state.businesses.error)
  const dispatch = useDispatch()
  const navigate =  useNavigate();
  const formSchema = Yup.object().shape({
    businessEntity:Yup.object().shape({
      gstRegistrationType: Yup.string().required("Please select registration type"),
      panNumber: Yup.string()
        .required("Please enter Pan Number")
        .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Please enter valid pan number"),
      panCardName: Yup.string()
        .required("Please enter name on pan card"),
      gstin: Yup.string()
        .when("$isGstinDisbale", (isGstinDisbale, schema) => {
          if(!isGstinDisbale){
            return schema.required("Please enter GSTIN").matches(/[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9]{1}[Z]{1}[A-Z,0-9]{1}$/, "Please enter valid GSTIN")
          }
        }),
      tanNumber: Yup.string()
        .required("Please enter TAN")
        .matches(
          /[A-Z]{4}[0-9]{5}[A-Z]{1}$/,
          "Please enter the valid TAN No."
        ),
      cinNumber: Yup.string().required("Please enter the CIN number")
        .matches(/[U,L]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/, "Please valid CIN number"),
      dateOfBirth:Yup.string().required("Please choose date")
    })
  });

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(formSchema),
    context: { isGstinDisbale }
  });
  const businessLocalData =  getBusinessFormData()

  if(typeof businessLocalData?.businessEntityNature === "undefined"){
    navigate("/add-business/BusinessInformation")
  }

  const setFieldData = function(localData){
    const businessEntity = localData?.businessEntity
    if(businessEntity){
      businessEntity.dateOfBirth = businessEntity?.dateOfBirth?new Date(businessEntity?.dateOfBirth ):""
      setIsGstinDisable(businessEntity.gstRegistrationType == "unregistered"?true:false)
      setValue("businessEntity",businessEntity)
    }
    
  }

  useEffect( ()=>{
    setFieldData(businessLocalData)
  },[])

  useEffect(()=>{
    let busRegType = props.gstRegistrationTypes?Object.keys(props.gstRegistrationTypes).map( (item, key) => {  return { value:item, label: props.gstRegistrationTypes[item]} } ):[]
    setBusinessRegType(busRegType)
  },[props.gstRegistrationTypes])
  
  
  // watch( (value, {name, type})=>{
  //   q0q.log(name, value, type)
  // } )

  const changeHandler = function (event, fnc){
    const regType = event?.value
    setIsGstinDisable(regType === "unregistered"?true:false)
    fnc(event?.value)
  }

  // useEffect( ()=>{
  //   console.log("Error", storeState.error)
  //   console.log("Success", storeState.success)
  // },[dispatch])

  const onSubmit = (data)=>{  
    
    //do something else
    dispatch(setFromData(data))
    const formData = getBusinessFormData();
    if(isGstinDisbale){
      delete formData.businessEntity.gstin
    }
    console.log(formData)
    dispatch(saveBusinessInformation(formData))
      .unwrap()
      .then((result)=>{
        if(result.success){
          dispatch(removeLocalData())
          navigate("/manage-business",  { replace: true })
        }
      }) 
  }
  
  return (
    <React.Fragment>
      <div className="col-md-6 col-lg-12">
        <div className="card payment-card">
          <div className="card-body pt-0">  
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      PAN Number
                    </label>
                    <input
                      {...register("businessEntity.panNumber")}
                      type="text"
                      defaultValue=""
                      placeholder="PAN Number"
                      className="form-control"
                    />
                    {errors?.businessEntity?.panNumber && <FormError message={errors?.businessEntity?.panNumber?.message} />}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      Name on PAN
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      {...register("businessEntity.panCardName")}
                      placeholder="Name on PAN"
                      className="form-control"
                    />
                    {errors?.businessEntity?.panCardName && <FormError message={errors?.businessEntity?.panCardName?.message} />}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      Date of Birth/Incorporation
                    </label>
                    <Controller
                      control={control}
                      name="businessEntity.dateOfBirth"
                      render={({ field }) => (
                        <DatePicker
                          placeholderText="Select date"
                          className={`input-txt form-control ${errors?.businessEntity?.dateOfBirth && "error"}`} 
                          onChange={(date) => field.onChange(date)}
                          dropdownMode="select"
                          showMonthDropdown
                          showYearDropdown
                          selected={field.value}
                          endDate={new Date()}
                        />
                      )}
                    />
                    {errors?.businessEntity?.dateOfBirth && <FormError message={errors?.businessEntity?.dateOfBirth?.message} />}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      Type of GST Registration
                    </label>
                    <Controller
                      control={control}
                      name={"businessEntity.gstRegistrationType"}
                      // value={status[0]['value']}
                      render={({ field }) => (
                        <SelectBox
                          defaultValue=""
                          className={`${errors?.businessEntity?.gstRegistrationType && "error"}`}
                          options={businessRegType}
                          isClearable={true}
                          onChange={(opt) => changeHandler(opt, field.onChange)}
                          value={businessRegType.find((option) => option.value == field.value)}
                        />
                      )}
                    />
                    {errors?.businessEntity?.gstRegistrationType && <FormError message={errors?.businessEntity?.gstRegistrationType?.message} />}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      GSTIN
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      disabled={isGstinDisbale}
                      {...register("businessEntity.gstin")}
                      placeholder="GSTIN"
                      className="form-control"
                    />
                    {errors?.businessEntity?.gstin && <FormError message={errors?.businessEntity?.gstin?.message} />}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      TAN
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      {...register("businessEntity.tanNumber")}
                      placeholder="TAN"
                      className="form-control"
                    />
                    {errors?.businessEntity?.tanNumber && <FormError message={errors?.businessEntity?.tanNumber?.message} />}
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group mb-3">
                    <label htmlFor="card-number" className="d-block">
                      CIN
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      {...register("businessEntity.cinNumber")}
                      placeholder="CIN"
                      className="form-control"
                    />
                    {errors?.businessEntity?.cinNumber && <FormError message={errors?.businessEntity?.cinNumber?.message} />}
                  </div>
                </div>
              </div>
              <div className="col-12 mb-3 text-right">
                <NavLink
                  style={{"height":"38px", "lineHeight": "24px"}}
                  to="/add-business/BusinessNatue"
                  className={"btn btn-primary btn-lg px-5 m-3"}>
                    Prev
                </NavLink>
                <button
                  type="submit"
                  className="btn btn-success btn-lg px-5">
                    Next
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      { (storeState.success || storeState.error)?<MessageAlert 
        type={storeState.success?"success":"error"}
        message={storeState.message}
        isLoading={storeState.loading}
      />:""}
      {
        (storeState.loading)? <Loading/>:""
      }
    </React.Fragment>
  );
}
